var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9948 9.14026C15.9948 10.3523 15.5133 11.5147 14.6563 12.3717C13.7992 13.2287 12.6368 13.7102 11.4248 13.7102C10.2128 13.7102 9.0504 13.2287 8.19337 12.3717C7.33633 11.5147 6.85486 10.3523 6.85486 9.14026C6.85486 7.92824 7.33633 6.76585 8.19337 5.90882C9.0504 5.05179 10.2128 4.57031 11.4248 4.57031C12.6368 4.57031 13.7992 5.05179 14.6563 5.90882C15.5133 6.76585 15.9948 7.92824 15.9948 9.14026Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9587 22.8406C4.86528 22.5961 0 17.5783 0 11.4249C0 5.11492 5.11492 0 11.4249 0C17.7348 0 22.8497 5.11492 22.8497 11.4249C22.8497 17.7348 17.7348 22.8497 11.4249 22.8497C11.3727 22.8501 11.3205 22.8501 11.2684 22.8497C11.165 22.8497 11.0616 22.8463 10.9587 22.8406ZM4.09353 18.634C4.00811 18.3887 3.97903 18.1273 4.00846 17.8692C4.03789 17.6111 4.12507 17.363 4.26352 17.1432C4.40198 16.9234 4.58815 16.7376 4.80823 16.5996C5.02831 16.4617 5.27663 16.375 5.53478 16.3461C9.9882 15.8532 12.889 15.8977 17.3207 16.3564C17.5792 16.3833 17.8281 16.4689 18.0485 16.6066C18.269 16.7442 18.4551 16.9304 18.5927 17.1509C18.7303 17.3713 18.8158 17.6203 18.8426 17.8788C18.8695 18.1373 18.837 18.3985 18.7476 18.6425C20.647 16.7208 21.7107 14.1268 21.7073 11.4249C21.7073 5.74614 17.1036 1.14249 11.4249 1.14249C5.74614 1.14249 1.14249 5.74614 1.14249 11.4249C1.14249 14.2331 2.26841 16.7786 4.09353 18.634Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_Icon.6d159fe088b5fb3f8520388a21a3770c.svg";
export { ForwardRef as ReactComponent };